import { render, staticRenderFns } from "./ConfirmMailMobile.vue?vue&type=template&id=45cfa060&scoped=true&"
import script from "./ConfirmMailMobile.vue?vue&type=script&lang=js&"
export * from "./ConfirmMailMobile.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmMailMobile.vue?vue&type=style&index=0&id=45cfa060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cfa060",
  null
  
)

export default component.exports